import { formatCurrency } from '../../utils/datetime';
import { useWorkspaceSales } from '../../hooks/useWorkspaceSales';

const ReportsStaff = () => {
  const { data, loading, error } = useWorkspaceSales();
  const currency = data?.currency || 'GHS';
  const rows = data?.reports?.byStaff || [];

  return (
    <div className="space-y-6">
      <div>
        <h2 className="font-display text-2xl font-light text-ink-900">Staff performance</h2>
        <p className="mt-1 text-sm text-ink-700/80">
          Bookings and deposits attributed to each team member at this location.
        </p>
      </div>

      {error && (
        <div className="border border-red-300 bg-red-50 px-4 py-3 text-sm text-red-800">{error}</div>
      )}

      <div className="overflow-x-auto bg-sand-50 ring-1 ring-ink-900/10">
        {loading ? (
          <div className="flex justify-center py-16">
            <div className="h-8 w-8 animate-spin rounded-full border-2 border-ink-900/20 border-t-saffron-500" />
          </div>
        ) : rows.length === 0 ? (
          <p className="px-5 py-16 text-center text-sm text-ink-700/70">
            No staff bookings yet at this location.
          </p>
        ) : (
          <table className="min-w-full text-left text-sm">
            <thead className="border-b border-ink-900/10 text-[11px] font-semibold uppercase tracking-[0.14em] text-ink-600/55">
              <tr>
                <th className="px-5 py-3">Staff</th>
                <th className="px-5 py-3">Bookings</th>
                <th className="px-5 py-3">Share</th>
                <th className="px-5 py-3 text-right">Deposits</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-ink-900/10">
              {rows.map((row) => (
                <tr key={row.id}>
                  <td className="px-5 py-3 font-medium text-ink-900">{row.name}</td>
                  <td className="px-5 py-3 tabular-nums text-ink-700/80">{row.visits}</td>
                  <td className="px-5 py-3 text-ink-700/80">{row.share}</td>
                  <td className="px-5 py-3 text-right font-medium tabular-nums text-ink-900">
                    {formatCurrency(row.revenue, currency)}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
};

export default ReportsStaff;
